"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logger = void 0;
const debug_1 = __importDefault(require("debug"));
const APP_NAME = 'h264-profile-level-id';
class Logger {
  constructor(prefix) {
    if (prefix) {
      this._debug = (0, debug_1.default)("".concat(APP_NAME, ":").concat(prefix));
      this._warn = (0, debug_1.default)("".concat(APP_NAME, ":WARN:").concat(prefix));
      this._error = (0, debug_1.default)("".concat(APP_NAME, ":ERROR:").concat(prefix));
    } else {
      this._debug = (0, debug_1.default)(APP_NAME);
      this._warn = (0, debug_1.default)("".concat(APP_NAME, ":WARN"));
      this._error = (0, debug_1.default)("".concat(APP_NAME, ":ERROR"));
    }
    /* eslint-disable no-console */
    this._debug.log = console.info.bind(console);
    this._warn.log = console.warn.bind(console);
    this._error.log = console.error.bind(console);
    /* eslint-enable no-console */
  }
  get debug() {
    return this._debug;
  }
  get warn() {
    return this._warn;
  }
  get error() {
    return this._error;
  }
}
exports.Logger = Logger;